import React from "react";
import styled from "styled-components";
import { useTheme } from "@material-ui/core";
import { Theme } from "../../../theme";

const StyledSection = styled.section`
  padding-left: 24px;
  /* border: 1px solid black; */
  margin-top: -8px;
  margin-left: -8px;
  margin-right: -8px;
  margin-bottom: 8px;
  border-top-left-radius: 4px;
  border-top-right-radius: 4px;
  display: flex;

  .cardTitle {
    margin-top: -4px;
    font-weight: 700px;
    font-size: 16px;
    color: #111;
  }

  .spacer {
    flex: 1;
  }
`;

export interface CameraHeaderProps {
  name: string;
  riskColor: string;
  description: string;
}

//Layout is determined here
const CameraHeader: React.FC<CameraHeaderProps> = props => {
  const theme: Theme = useTheme();
  //   const mdUp = useMediaQuery(theme.breakpoints.up("md"));

  return (
    <>
      <StyledSection style={{ backgroundColor: props.riskColor }}>
        <div className="cardTitle">
          <p>{props.name}</p>
        </div>
        <div className="spacer"></div>
      </StyledSection>
    </>
  );
};

export default CameraHeader;
